import { withInstall, withNoopInstall } from '@bigin/utils'

import Menu from './src/menu'
import MenuItem from './src/menu-item.vue'
import MenuItemGroup from './src/menu-item-group.vue'
import SubMenu from './src/sub-menu'
import MenuToggle from './src/menu-toggle.vue'

export const BMenu = withInstall(Menu, {
  MenuItem,
  MenuItemGroup,
  SubMenu,
  MenuToggle,
})
export default BMenu
export const BMenuItem = withNoopInstall(MenuItem)
export const BMenuItemGroup = withNoopInstall(MenuItemGroup)
export const BSubMenu = withNoopInstall(SubMenu)
export const BMenuToggle = withNoopInstall(MenuToggle)

export * from './src/menu'
export * from './src/menu-item'
export * from './src/menu-item-group'
export * from './src/menu-toggle'
export * from './src/sub-menu'
export * from './src/types'
